var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "setting_svg__st0",
    d: "M24 13.61v-3.23c-1.65-.59-2.69-.75-3.22-2.02-.53-1.27.1-2.13.85-3.71l-2.29-2.28c-1.56.74-2.43 1.38-3.71.85-1.26-.53-1.42-1.58-2.01-3.22h-3.23c-.58 1.64-.76 2.69-2.02 3.22-1.27.53-2.13-.1-3.71-.85L2.37 4.65c.73 1.57 1.38 2.43.85 3.71C2.69 9.63 1.64 9.8 0 10.38v3.23c1.63.58 2.69.75 3.22 2.02.53 1.28-.11 2.17-.85 3.71l2.29 2.29c1.56-.74 2.43-1.38 3.71-.85 1.27.53 1.44 1.58 2.02 3.22h3.23c.58-1.64.75-2.69 2.03-3.22 1.26-.52 2.12.1 3.7.85l2.29-2.29c-.74-1.56-1.38-2.43-.85-3.71.52-1.27 1.58-1.44 3.21-2.02zm-12 3.38c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.23 5-5 5zm3-5c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3z"
  })));
};
export default SvgSetting;